/* Load polyfill:
 * This file and its dependencies get bundled into the "polyfills" chunk by WebPack and loaded as first scripts.
 * Add loading code of further polyfills in here as needed. */

const babel_polyfill = require('babel-polyfill')
const url_polyfill = require('url-search-params-polyfill')

import 'whatwg-fetch'
